import timeutils from 'utils/wt-time-utils'
import { cashCount } from '@/utils/formUtils'
import { channelOptions } from 'json/goods-order-options'
import { batchBusiness } from 'json/data-statistics'
import { getEnumeration } from 'enumeration'
export default {
  cpsPaymentList (data) {
    data.forEach(item => {
      item.pay_date = item.payDate && timeutils.format(item.payDate)
      item.amount = item.payAmount && cashCount(item.payAmount, true, 2)
      item.birth_date = item.birthday && timeutils.format(item.birthday, 'date')
      item.pay_channel = item.payChannel && getEnumeration(item.payChannel, channelOptions)
    })
    return data
  },
  getCurrentBatch (data) {
    data.batch_startTime = data.batchStartTime && timeutils.format(data.batchStartTime)
    data.day_startTime = data.dayStartTime && timeutils.format(data.dayStartTime)// 本次跑批开始时间
    data.day_endTime = data.dayEndTime && timeutils.format(data.dayEndTime)// 本次跑批结束时间
    data.percentage_progress = (data.percentageProgress && data.percentageProgress * 100).toFixed(2) + '%'
    return data
  },
  getgetExceptionList (data) {
    data.forEach(item => {
      item.created_date = item.createdDate && timeutils.format(item.createdDate)
      item.business_show = item.business && getEnumeration(item.business, batchBusiness)
    })
    return data
  }
}
